import { Controller } from "@hotwired/stimulus"

// The pin editor's dialog on a home (assistants/_pins_dialog). Every "Edit
// pins" link loads the editor into the "home_pins" frame inside it. The dialog
// opens the moment that load STARTS, with a loading line, rather than when the
// editor lands: waiting for the server read as a slow page reload.
//
// Closing it (Done, Esc, a click outside) empties the frame, so the next "Edit
// pins" loads it afresh, and reloads only the Pins widget on the home, which
// shows what changed - the editor saves as you go. It used to revisit the whole
// home for that.
export default class extends Controller {
    // turbo:before-fetch-request: a link aimed at the frame is on its way.
    loading(event) {
        const frame = this.element.querySelector("turbo-frame#home_pins")
        if (!frame || !frame.contains(event.target) && event.target !== frame) return
        if (this.element.open) return
        const note = document.createElement("p")
        note.className = "home-pins-loading"
        note.textContent = "Loading your pins…"
        frame.replaceChildren(note)
        this.element.showModal()
    }

    // The editor landed: open, if it came without a click (?edit_pins=1).
    open(event) {
        if (event.target.id !== "home_pins" || this.element.open) return
        this.element.showModal()
    }

    // Done in the editor: close here instead of reloading the home.
    done(event) {
        if (!this.element.open) return
        event.preventDefault()
        this.element.close()
    }

    closed() {
        const frame = this.element.querySelector("turbo-frame#home_pins")
        if (frame) {
            frame.removeAttribute("src")
            frame.replaceChildren()
        }
        if (window.location.search.includes("edit_pins=1")) {
            window.history.replaceState(window.history.state, "", window.location.href.replace(/[?&]edit_pins=1/, ""))
        }
        document.querySelectorAll("turbo-frame[id^='home_widget_pinned']").forEach((widget) => widget.reload?.())
    }

    // A click on the backdrop (the dialog element itself, outside its box).
    backdrop(event) {
        if (event.target === this.element) this.element.close()
    }
}
